import { deleteDoc } from "firebase/firestore";
import { useState } from "react";
import { BsThreeDots } from "react-icons/bs";
import { useAppSelector } from "../../../store/hooks";
import { doc } from "firebase/firestore";
import { db } from "../../../shared/firebase";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { AiOutlineDelete } from "react-icons/ai";

const EditComment = ({
  singleDoc,
  showOptionFor,
  setShowOptionFor,
  media_type,
  id,
  setEditingCommentFor,
  setCommentHiden,
}) => {
  const currentUser = useAppSelector((state) => state.auth.user);
  const [isShowPrompt, setIsShowPrompt] = useState(false);
  const [show] = useAutoAnimate();
  return (
    <>
      <div className="relative z-[39]">
        <button
          onClick={() =>
            showOptionFor === singleDoc.id
              ? setShowOptionFor(null)
              : setShowOptionFor(singleDoc.id)
          }
          className="transition duration-300 mt-4 h-8 w-8 bg-transparent rounded-full flex items-center justify-center hover:bg-gray-darken"
        >
          <BsThreeDots size={20} />
        </button>
        {showOptionFor === singleDoc.id && (
          <div className="absolute -left-8 w-[70px] flex flex-col gap-1 bg-gray-darken rounded-md px-3 py-2 shadow-md">
            {currentUser && currentUser.uid === singleDoc.data()?.user.uid && (
              <>
                <button
                  onClick={() => {
                    setEditingCommentFor(singleDoc.id);
                    setShowOptionFor(null);
                  }}
                  className="transition duration-300 hover:text-white text-left"
                >
                  Edit
                </button>
                <button
                  onClick={() => {
                    setIsShowPrompt(true);
                    setShowOptionFor(null);
                  }}
                  className="transition duration-300 hover:text-white text-left"
                >
                  Delete
                </button>
              </>
            )}
            {(!currentUser ||
              currentUser.uid !== singleDoc.data()?.user.uid) && (
              <button
                onClick={() =>
                  setCommentHiden((prev) => prev.concat(singleDoc.id))
                }
                className="transition duration-300 hover:text-white"
              >
                Hide
              </button>
            )}
          </div>
        )}
      </div>
      {showOptionFor === singleDoc.id && (
        <div
          onClick={() => setShowOptionFor(null)}
          className="fixed top-0 left-0 w-full h-full z-[35]"
        ></div>
      )}
      <div ref={show}>
        {isShowPrompt && (
          <>
            <div className="fixed top-[35%] md:left-[35%] left-[5%] right-[5%] md:w-[450px] max-w-[90vw] min-h-[100px] px-5 py-4 z-40 bg-dark-lighten rounded-md shadow-md">
              <div className="mx-auto mb-7 h-16 w-16 rounded-full shadow-md shadow-gray-darken bg-gradient-to-t from-transparent to-gray-darken flex items-center justify-center">
                <AiOutlineDelete size={40} className="text-primary " />
              </div>
              <p className="text-white text-lg">
                Do you really want to remove this comment ?
              </p>
              <div className="flex gap-5 mt-8 justify-end">
                <button
                  onClick={() =>
                    deleteDoc(doc(db, `${media_type}-${id}`, singleDoc.id))
                  }
                  className="px-4 py-2 rounded-full bg-dark-lighten-2 text-white hover:bg-white hover:text-dark-darken transition duration-300"
                >
                  Yes
                </button>
                <button
                  onClick={() => setIsShowPrompt(false)}
                  className="px-4 py-2 rounded-full text-white bg-dark-lighten-2 hover:bg-primary  transition duration-300"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div
              onClick={() => setIsShowPrompt(false)}
              className="fixed top-0 left-0 w-full h-full z-30 bg-black/60"
            ></div>
          </>
        )}
      </div>
    </>
  );
};

export default EditComment;
